import classNames from 'classnames';
import React__default, { useEffect } from 'react';
import Styles from './BottomSheet.module.scss.js';
import './BottomSheet.scss.js';
import { ReactComponent as SvgNfCloseWhite } from '../../icons/nf_closeWhite.svg.js';

const SwipeableBottomSheet = require("react-swipeable-bottom-sheet");
const BottomSheet = ({ isOpen, handleToggle, children, className, id, bottomSheetTitle, titleClass, closeIconClass, topLineClass, fullScreen = false, bottomSheetHeaderClassName, bodyBgColor, style, disableSwipe = false }) => {
    useEffect(() => {
        const body = document.querySelector("body");
        if (body) {
            body.style.overflow = isOpen ? "hidden" : "unset";
        }
        return () => {
            const body = document.querySelector("body");
            if (!body) {
                return;
            }
            body.style.overflow = "unset";
        };
    }, [isOpen]);
    const onChange = () => {
        handleToggle();
    };
    if (!isOpen)
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement(SwipeableBottomSheet, { open: isOpen, handleToggle: handleToggle, shadowTip: false, topShadow: false, style: Object.assign({ zIndex: 1000 }, style), overlayStyle: { backgroundColor: "rgba(0,0,0)" }, onChange: onChange, fullScreen: fullScreen, bodyStyle: { backgroundColor: bodyBgColor !== null && bodyBgColor !== void 0 ? bodyBgColor : "#fff" }, swipeableViewsProps: {
            disabled: disableSwipe
        } },
        React__default.createElement("div", { className: classNames(Styles.topLine, topLineClass) }),
        bottomSheetTitle && (React__default.createElement("div", { className: classNames(Styles.bottomSheetHeader, "container", bottomSheetHeaderClassName) },
            React__default.createElement("div", { className: classNames(Styles.bottomSheetTitle, titleClass) }, bottomSheetTitle),
            React__default.createElement("div", { className: classNames(Styles.closeIcon, closeIconClass), onClick: handleToggle, id: id ? `${id}--closeBtn` : "" },
                React__default.createElement(SvgNfCloseWhite, null)))),
        React__default.createElement("div", { className: classNames(Styles.contentMain, className, "container") }, children)));
    // return <></>;
};

export { BottomSheet as default };
//# sourceMappingURL=BottomSheet.js.map
